import styled from 'styled-components';
import { Card } from '@zillow/constellation';

export const Container = styled(Card)`
  width: 100%;
  padding: 0;
`;
